import appcolors from "./constants/Colors";

const globalStyle = {
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey}}`,
        // boxShadow:"none !important",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: 0,
    },
    "& .Mui-disabled": {
      cursor: "not-allowed",
    },
  },
  
  selectType: {
    "&.MuiFormControl-root .MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #EA580C`,
      boxShadow: "0px 4px 10px 0px #ebebeb",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #EA580C`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #EA580C`,
    },
  },
};

export default globalStyle;
